import React from 'react';
import cn from 'classnames';

import { CaretDown } from '@periodica/ui-kit/icons';

import * as styles from './styles.module.css';

export interface AccordionItemArgs {
  question: string;
  answer: string | React.ReactNode;
  defaultIsOpen?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export function AccordionItem({
  question,
  answer,
  defaultIsOpen = false,
  className = '',
  style = {},
}: AccordionItemArgs) {
  const [isItemOpen, setIsItemOpen] = React.useState(defaultIsOpen);

  const handleOpenItem = () => {
    setIsItemOpen(!isItemOpen);
  };

  return (
    <div className={cn([styles.accordionItemContainer, className])} style={style}>
      <div className={styles.questionContainer} onClick={handleOpenItem}>
        <p className={styles.question}>{question}</p>
        <CaretDown className={cn({ [styles.openIcon]: true, [styles.open]: isItemOpen })} />
      </div>
      <div className={cn({ [styles.answerContainer]: true, [styles.openBlock]: isItemOpen })}>
        <div className={styles.answer}>{answer}</div>
      </div>
    </div>
  );
}
